import React, { useState } from "react";
import localization from "assets/localization/localization";
import DatePicker from "components/sales/datePicker/datePicker";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "../Input/dropDownInput/dropDownInput";

const CompetitionMappingFilter = ({ applyFilter, createdByDropdown, cityDropdown }) => {
  const filterInputs = {
    site_name: "",
    created_by_name: "",
    solution_type: "",
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label={"Site Name"}
        type="text"
        value={
          window.localStorage?.competition_mapping_list_filter &&
          window.localStorage?.competition_mapping_list_filter
            ? JSON.parse(window.localStorage?.competition_mapping_list_filter)["site_name"]
            : ""
        }
        handleChange={(value) => {
          setFilterFieldsData({ ...filterFieldsData, site_name: value });
        }}
      />
      <DropDownInput
        label="Solution Type"
        data={[
          {
            id: "Automatic",
            name: "Automatic",
          },
          {
            id: "Manual",
            name: "Manual",
          },
        ]}
        getIdValue={(val) => {
          setFilterFieldsData({ ...filterFieldsData, solution_type: val?.id });
        }}
        value={
          window.localStorage?.competition_mapping_list_filter &&
          window.localStorage?.competition_mapping_list_filter
            ? JSON.parse(window.localStorage?.competition_mapping_list_filter)["solution_type"]
            : ""
        }
      />
      <DropDownInput
        label="Created By"
        data={createdByDropdown}
        getIdValue={(val) => {
          setFilterFieldsData({ ...filterFieldsData, created_by_name: val?.id });
        }}
        value={
          window.localStorage?.competition_mapping_list_filter &&
          window.localStorage?.competition_mapping_list_filter
            ? JSON.parse(window.localStorage?.competition_mapping_list_filter)["created_by_name"]
            : ""
        }
      />
      <DropDownInput
        label="City"
        data={cityDropdown}
        getIdValue={(val) => {
          setFilterFieldsData({ ...filterFieldsData, city: val?.id });
        }}
        value={
          window.localStorage?.competition_mapping_list_filter &&
          window.localStorage?.competition_mapping_list_filter
            ? JSON.parse(window.localStorage?.competition_mapping_list_filter)["city"]
            : ""
        }
      />
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            applyFilter(filterInputs);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default CompetitionMappingFilter;
